import React from 'react';
import { connect } from 'react-redux';
import { Title, Modal } from '@common/components';
import { popIn } from '@common/utils/services';
import JournalForm from '../Form';
import { createJournal } from '@resources/Journal/actions';
import { useIntl } from 'react-intl';
import { fetchModulesBySubmoduleCode } from '@resources/Module/actions';

const Create = (props) => {
	const { createJournal, visible, onCancel, module } = props;
	const intl = useIntl();

	const handleSubmit = (data) => {
		return createJournal(data)
			.then((response) => {
				popIn(
					'success',
					intl.formatMessage({
						id: 'message.success.journal.create',
						defaultMessage:
							'A new Journal has been successfully created',
					})
				);
				onCancel && onCancel();
			})
			.catch((err) => Promise.reject(err));
	};

	return (
		<Modal visible={visible} onCancel={() => onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.new.journal',
					defaultMessage: 'Create Journal',
				})}
			</Title>
			<JournalForm onSubmit={handleSubmit} {...props} module={module} />
		</Modal>
	);
};

const mapStateToProps = ({
	journals,
	modules,
	event,
	facility,
	ministry,
	cellGroup,
	organization,
}) => {
	return {
		journals,
		ministry,
		facility,
		modules,
		event,
		cellGroup,
		organization,
	};
};

export default connect(mapStateToProps, {
	createJournal,
	fetchModulesBySubmoduleCode,
})(Create);
